<template>
	<div class="items-list--item">
		<b-row align-v="center">
			<b-col md="3">
				<div class="items-list--item-label">Person</div>
				{{ exclusion.pseudonym.label }}
			</b-col>
			<b-col md="8">
				<div class="items-list--item-label">Ausgeschlossen</div>
				<div>
					<span v-if="exclusion.validUntil">bis {{ exclusion.validUntil | date }}</span>
					<span v-else>unbefristet</span>
					| {{ typeLabel }}
				</div>
			</b-col>
			<b-col md="1" class="text-right">
				<a href="#" @click.prevent="remove = true">
					<Icon icon="bin" size="1comma5x" color="primary" />
				</a>
			</b-col>
		</b-row>
		<RemovePopUp
			v-if="remove"
			:exclusion="exclusion"
			@remove="$emit('remove')"
			@hidden="remove = false"
		/>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import RemovePopUp from "@/vue/customer-area/exclusion/RemovePopUp";

const TYPE_LABELS = {
	total: 'alle Stellenprofile',
};

export default {

	components: {
		RemovePopUp,
		Icon,
	},

	props: {
		exclusion: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			remove: false,
		};
	},

	computed: {
		typeLabel ()
		{
			return TYPE_LABELS[this.exclusion.type] || this.exclusion.jobProfile.info;
		},
	},
}
</script>
